<template>
  <div
    v-if="!countNodosActivos"
    key="emptyContent"
  >
    <MoleculeEditionAssetContentEmpty/>
  </div>
  <div
    v-else
    key="loadedContent"
  >
    <MoleculeContentNode/>
    <MoleculeEditionAssetContentComments/>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionAssetContent',

  components: {
    MoleculeContentNode: () => import('@/components/molecules/MoleculeContentNode'),
    MoleculeEditionAssetContentEmpty: () => import('@/components/molecules/MoleculeEditionAssetContentEmpty'),
    MoleculeEditionAssetContentComments: () => import('@/components/molecules/MoleculeEditionAssetContentComments')
  },

  computed: {
    countNodosActivos () {
      return this.$store.getters.getProyectNodesEnrollment.length
    }
  }
}
</script>
